export default __webpack_public_path__ + "static/media/mobile_navbar 2.0d671960.png";